import { IsDateString, IsOptional } from "class-validator";

/**
 * Cursor pagination for feed reads. `before` is the `created_at` of the
 * last item the client has; the response holds the next page of older
 * items. Omit it for the first page.
 */
export class FeedPageQueryDto {
  @IsOptional()
  @IsDateString()
  before?: string;
}
